import { Link, LinkProps } from "react-router";
import { Routes } from "@/config/routes";
import { RouteKeys, RouteParams, RouteQuery } from "@/types/router";

function getRouteFromKey(obj: any, key: string): any {
	return key.split(".").reduce((acc, part) => acc?.[part], obj);
}

export type AppLinkProps<Key extends RouteKeys> = Omit<LinkProps, "to"> & {
	to: Key;
	params: RouteParams<Key>;
	query?: RouteQuery<Key>;
};

export function AppLink<Key extends RouteKeys>({ to, params, query, ...rest }: AppLinkProps<Key>) {
	const route = getRouteFromKey(Routes, to);
	return <Link {...rest} to={route.build(params, query)} />;
}
